var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.91071 1H16.3393C16.5069 1 16.6429 1.13591 16.6429 1.30357V6.66071C16.6429 6.82838 16.5069 6.96429 16.3393 6.96429H9.91071C9.74305 6.96429 9.60714 6.82838 9.60714 6.66071V1.30357C9.60714 1.13591 9.74305 1 9.91071 1ZM0.803571 1H7.23214C7.39981 1 7.53571 1.13591 7.53571 1.30357V6.66071C7.53571 6.82838 7.39981 6.96429 7.23214 6.96429H0.803571C0.635908 6.96429 0.5 6.82838 0.5 6.66071V1.30357C0.5 1.13591 0.635908 1 0.803571 1ZM0.5 14.6964V9.33929C0.5 9.17162 0.635908 9.03571 0.803571 9.03571H7.23214C7.39981 9.03571 7.53571 9.17162 7.53571 9.33929V14.6964C7.53571 14.8641 7.39981 15 7.23214 15H0.803571C0.635908 15 0.5 14.8641 0.5 14.6964ZM16.3393 15H9.91071C9.74305 15 9.60714 14.8641 9.60714 14.6964V9.33929C9.60714 9.17162 9.74305 9.03571 9.91071 9.03571H16.3393C16.5069 9.03571 16.6429 9.17162 16.6429 9.33929V14.6964C16.6429 14.8641 16.5069 15 16.3393 15Z",
    stroke: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.985d6b988aacea62da12a1bde41326ba.svg";
export { ForwardRef as ReactComponent };